'use client';

import { useEffect, useState, type CSSProperties } from 'react';
import { useTranslations } from 'next-intl';
import { Marquee } from 'components/shared/marquee';
import { SCIENCE_PARTNER_LOGOS } from 'components/science/home/scienceLogoArt';
import styles from './PartnerLogoMarquee.module.css';

const REPEAT = 3;

export const PartnerLogoMarquee = ({
  'aria-label': ariaLabel,
  className,
}: {
  'aria-label'?: string;
  className?: string;
}) => {
  const t = useTranslations('homepage');
  const [play, setPlay] = useState(true);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => setPlay(!mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return (
    <section
      className={className ? `${styles.strip} ${className}` : styles.strip}
      aria-label={ariaLabel ?? t('homepage.scienceLibrary.aria.partners')}
      data-header-theme="light"
    >
      <p className={styles.heading}>
        {t('homepage.scienceLibrary.marqueeHeading')}
      </p>
      <div className={styles.masked}>
        <Marquee gradient={false} speed={24} play={play} pauseOnHover>
          <div className={styles.row} aria-hidden>
            {Array.from({ length: REPEAT }).flatMap((_, r) =>
              SCIENCE_PARTNER_LOGOS.map((logo) => (
                <span
                  key={`${logo.id}-${r}`}
                  className={styles.mark}
                  style={{ '--lh': `${logo.height}px` } as CSSProperties}
                >
                  <img
                    src={logo.src}
                    alt=""
                    width={logo.width}
                    height={logo.height}
                    draggable={false}
                  />
                </span>
              )),
            )}
          </div>
        </Marquee>
      </div>
    </section>
  );
};

export default PartnerLogoMarquee;
